export default __webpack_public_path__ + "static/media/AboutSamBackgroundOne.07293488.JPG";